const activityEnum = Object.freeze({
    ENABLE: 5,
    DISABLE: 10
});
export default activityEnum;
